module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/autonomic-nervous-system-80be73180f83c9332554d2013615e892.jpeg";